import { createSlice, current } from "@reduxjs/toolkit";
import Swal from "sweetalert2";

const AddToCartSlice = createSlice({
  name: "cart",
  initialState: {
    addTCLoader: false,
    cartList: [],
    cartSummeryData: null,
    cartCountNo: 0,
    removeCILoader: false,
  },
  reducers: {
    cartCount: (state, action) => {
      return {
        ...state,
        cartCountNo: action.payload,
      };
    },
    cartSummaryList: (state, action) => {
      return {
        ...state,
        cartSummeryData: action?.payload,
      };
    },
    cartListPrice: (state, action) => {
      const { id, count, dCount } = action.payload;
      console.log(dCount, count, "final");
      let final = [...current(state.cartList)];
      const finalListData = final?.map((data) => {
        if (data.cartId === id) {
          return {
            ...data,
            addCount: dCount ? dCount - 1 : count + 1,
          };
        } else {
          return data;
        }
      });
      console.log(finalListData, "final");
      // const finalListData = final?.map((data)=> {
      //     return{
      //         ...data,
      //         addVariant : data?.addVariant?.map((vList)=> {
      //             if(vList?._id === id){
      //                   return{
      //                         ...vList,
      //                         variantList : vList?.variantList.map((list,vIndex)=> {
      //                             console.log(list?._id,sizeId,"list?._id===sizeId")
      //                           if(list?._id===sizeId){
      //                               return {
      //                                   ...list,
      //                                   newPrice : list?.sellingPrice*sellingPrice
      //                               }
      //                           }else{
      //                               return list
      //                           }
      //                       })
      //                   }
      //             } else{
      //                 return vList
      //             }
      //         })
      //     }
      // })

      return {
        ...state,
        cartList: finalListData,
      };
    },
    addToCartRequest: (state, action) => {
      return {
        ...state,
        addTCLoader: true,
      };
    },
    addToCartSuccess: (state, action) => {
      console.log(action.payload, "HELLOOOOO");
      Swal.fire({
        position: "center",
        icon: "success",
        text: action?.payload?.message,
      });
      return {
        ...state,
        addTCLoader: false,
      };
    },
    addToCartFailure: (state, action) => {
      Swal.fire({
        position: "center",
        icon: "error",
        text: action?.payload?.message,
      });
      return {
        ...state,
        addTCLoader: false,
      };
    },
    addToCartListRequest: (state, action) => {
      return {
        ...state,
        addTCLoader: true,
      };
    },
    addToCartListSuccess: (state, action) => {
      return {
        ...state,
        cartList: action.payload,
        addTCLoader: false,
      };
    },
    addToCartListFailure: (state, action) => {
      Swal.fire({
        position: "center",
        icon: "error",
        text: action?.payload?.message,
      });
      return {
        ...state,
        addTCLoader: false,
        cartList:null
      };
    },
    removeCartItemRequest: (state, action) => {
      return {
        ...state,
        removeCILoader: true,
      };
    },
    removeCartItemSuccess: (state, action) => {
      return {
        ...state,
        removeCILoader: false,
      };
    },
    removeCartItemFailure: (state, action) => {
      Swal.fire({
        position: "center",
        icon: "error",
        text: action?.payload?.message,
      });
      return {
        ...state,
        removeCILoader: false,
      };
    },
  },
});

export const {
  addToCartFailure,
  addToCartRequest,
  addToCartSuccess,
  addToCartListFailure,
  addToCartListRequest,
  addToCartListSuccess,
  cartListPrice,
  cartSummaryList,
  cartCount,
  removeCartItemRequest,
  removeCartItemSuccess,
  removeCartItemFailure,
} = AddToCartSlice.actions;

export default AddToCartSlice.reducer;
